import 'vite/modulepreload-polyfill'
import { initVideoPlayer } from './components/video-player.js'
import './main.css'

// Initialize video player only if videos exist on the page
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.video-element');
  if (videos.length > 0) {
    initVideoPlayer();
  }
});
// Make product cards clickable - navigate to product link when clicked
document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card-wrapper');
  
  productCards.forEach((card) => {

    card.addEventListener('click', function(e) {
      // Find the product link within this card
      const productLink = card.querySelector('a.the-product-link');
      
      if (productLink) {
        // Check if the click was not on a button or link (avoid conflicts)
        const clickTarget = e.target.closest('a, button');

        // Only navigate if click wasn't on an interactive element
        if (!clickTarget || clickTarget === productLink) {
          window.location.href = productLink.href;
        }
      }
    });
    
    // card.style.cursor = 'pointer';
  });
});


